// src/services/socket.js
import { io } from "socket.io-client";
import { getDevUserId } from "./devIdentity";

//const SOCKET_URL = "https://32c4-196-191-240-81.ngrok-free.app";
// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:3001";
// socket.js
const SOCKET_URL =
  window.APP_CONFIG?.SOCKET_URL ||
  process.env.REACT_APP_SOCKET_URL ||
  "http://localhost:3001";
function getInitData() {
  if (window.Telegram?.WebApp?.initData) return window.Telegram.WebApp.initData;
  return localStorage.getItem("dev_init_data") || "";
}

let socket = null;

// Listeners can be registered before the real socket exists (this is exactly
// what was happening — GameContext mounts and calls .on() before AuthContext
// has finished its async api.getMe() call and created the socket).
// Keep them here so we can re-attach them the moment a socket exists.
const listenerRegistry = new Map(); // event -> Set<handler>

function attachRegisteredListeners(target) {
  for (const [event, handlers] of listenerRegistry.entries()) {
    for (const handler of handlers) target.on(event, handler);
  }
}

const socketService = {
  connect() {
    if (socket?.connected) return socket;
    const devUserId = getDevUserId();

    socket = io(SOCKET_URL, {
      auth: {
        initData: getInitData(),
        userId: devUserId ? Number(devUserId) : undefined,
      },
      transportOptions: {
        polling: {
          extraHeaders: {
            "ngrok-skip-browser-warning": "true", // ADD THIS
          },
        },
      },
      transports: ["polling", "websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    socket.on("connect", () => console.log("🔌 Socket connected:", socket.id));
    socket.on("disconnect", (reason) =>
      console.log("🔌 Socket disconnected:", reason),
    );
    socket.on("connect_error", (err) =>
      console.error("🔌 Socket error:", err.message),
    );

    // Re-attach anything that was registered before this socket existed
    attachRegisteredListeners(socket);

    return socket;
  },

  disconnect() {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  get raw() {
    return socket;
  },
  on(event, handler) {
    if (!listenerRegistry.has(event)) listenerRegistry.set(event, new Set());
    listenerRegistry.get(event).add(handler);
    socket?.on(event, handler); // attach immediately too, if socket already exists
  },
  off(event, handler) {
    listenerRegistry.get(event)?.delete(handler);
    socket?.off(event, handler);
  },

  // ── Lobby (stake → cartela selection) ──────────────────────────────────
  selectStake(roomId) {
    socket?.emit("select_stake", { roomId });
  },
  selectCartela(roomId, cartelaId) {
    socket?.emit("select_cartela", { roomId, cartelaId });
  },
  deselectCartela(roomId, cartelaId) {
    socket?.emit("deselect_cartela", { roomId, cartelaId });
  },

  // ── In-game ──────────────────────────────────────────────────────────────
  claimBingo(roomId, cartelaId, markedCells) {
    socket?.emit("claim_bingo", { roomId, cartelaId, markedCells });
  },
  leaveRoom(roomId) {
    socket?.emit("leave_room", { roomId });
  },
};

export default socketService;
